import { render, staticRenderFns } from "./bcPromoter.vue?vue&type=template&id=653c73b9&scoped=true&"
import script from "./bcPromoter.vue?vue&type=script&lang=js&"
export * from "./bcPromoter.vue?vue&type=script&lang=js&"
import style0 from "./bcPromoter.vue?vue&type=style&index=0&id=653c73b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c73b9",
  null
  
)

export default component.exports